import React, { useState } from 'react';
import { IonHeader, IonToolbar, IonTitle, IonContent, IonPage, IonButtons, IonMenuButton, IonRow, IonCol, IonButton, IonList, IonItem, IonLabel, IonText, IonTextarea, IonToast } from '@ionic/react';
import './Login.scss';

interface OwnProps { }

interface DispatchProps { }

interface TermsAndConditionProps extends OwnProps, DispatchProps { }

const TermsAndCondition: React.FC<TermsAndConditionProps> = () => {

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton></IonMenuButton>
          </IonButtons>
          <IonTitle>Terms & Condition</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>

      </IonContent>


    </IonPage>
  );
};
export default TermsAndCondition;